module.exports = __webpack_public_path__ + "static/media/rowexpansionexpandedicon.6d123be0.svg";